<template>
  <div class="app-main-content">
    <div class="details-view">
      <div class="main-content">
        <div class="tabs-container">
          <el-tabs v-model="activeTabName" type="card" style="width:100%" @tab-click="handleClick">
            <el-tab-pane v-if="$checkPermission(['module_PRQuotationFCL'])" :key="1" :label="$t('Pricing.FCL')" name="qutFcl">
              <quotation-list ref="qutFcl" :quotation-type="PriceConstant.QUOTATION_FCL" />
            </el-tab-pane>
            <el-tab-pane v-if="$checkPermission(['module_PRQuotationLCL'])" :key="2" :label="$t('Pricing.LCL')" name="qutLcl">
              <quotation-list ref="qutLcl" :quotation-type="PriceConstant.QUOTATION_LCL" />
            </el-tab-pane>
            <el-tab-pane v-if="$checkPermission(['module_PRQuotationAir'])" :key="3" :label="$t('Pricing.Air')" name="qutAir">
              <quotation-list ref="qutAir" :quotation-type="PriceConstant.QUOTATION_AIR" />
            </el-tab-pane>
            <el-tab-pane :key="4" :label="$t('CargoMsg.Cargo_PrePort')" name="prePort">
              <quotation-list ref="prePort" :quotation-type="PriceConstant.QUOTATION_PRE_PORT" />
            </el-tab-pane>
            <el-tab-pane :key="5" :label="$t('CargoMsg.Cargo_FinalMile')" name="lastMile">
              <quotation-list ref="lastMile" :quotation-type="PriceConstant.QUOTATION_LAST_MILE" />
            </el-tab-pane>
          </el-tabs>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import quotationList from './components/quotationList'
import * as PriceConstant from '@/class/cargo/model/parameters/PriceConstant'

export default {
  name: 'Quotation',
  components: { quotationList },
  data() {
    return {
      PriceConstant,
      activeTabName: 'qutFcl'
    }
  },
  beforeMount() {
    const qutFcl = this.$checkPermission(['module_PRQuotationFCL'])
    const qutLcl = this.$checkPermission(['module_PRQuotationLCL'])
    const qutAir = this.$checkPermission(['module_PRQuotationAir'])
    if (qutFcl) this.activeTabName = 'qutFcl'
    if (!qutFcl && qutLcl) this.activeTabName = 'qutLcl'
    if (!qutFcl && !qutLcl && qutAir) this.activeTabName = 'qutAir'
  },
  methods: {
    // tab 页签点击事件
    handleClick(tab, event) {
      // console.log(tab, event)
      // if (tab.name === this.activeTabName && this.$refs[this.activeTabName]) {
      //   this.$refs[this.activeTabName].fetchOrderRequirement()
      // }
    }
  }
}
</script>

<style scoped>

</style>
